module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Safe-6833d8b4f3fdbbd285ee3b13b08cc005.svg";